


































import Vue from "vue";
import { Wyrob } from "@megarax/client/src/resources/plm/Wyrob";

import { Komponent } from "@megarax/client/src/resources/plm/Komponent";
import DefaultRevisionSheet from "@/components/DefaultRevisionSheet.vue";

import { createComponent } from "@vue/composition-api";
import ResourceItemReference from "@/components/resource/ResourceItemReference";

export default createComponent({
  components: {
    DefaultRevisionSheet,
    ResourceItemReference,
  },
  props: {
    value: {
      type: Komponent,
      required: true,
    },
  },
  setup(props, ctx) {
    return {};
  },
});
